/* eslint-disable import-x/no-default-export */
import Chance from 'chance';

const chance = new Chance();

export default () =>
  chance.pickset(
    [
      {
        id: '5069',
        parent: {
          id: '1002',
        },
      },
      {
        id: '5070',
        parent: {
          id: '1002',
        },
      },
      {
        id: '5071',
        parent: {
          id: '1002',
        },
      },
      {
        id: '1000',
        parent: null,
      },
      {
        id: '1005',
        parent: null,
      },
    ],
    chance.integer({ min: 0, max: 5 }),
  );
